import { MatomoProvider } from '@datapunt/matomo-tracker-react';
import { ConnectedRouter } from 'connected-react-router';
import 'core-js/es/map';
import 'core-js/es/set';
import 'core-js/stable';
import * as React from 'react';
import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import * as ReactDOM from 'react-dom';
import { I18nextProvider } from 'react-i18next';
import { Provider } from 'react-redux';
import { App } from './App';
import { SESSION_KEY_APP_STATE } from './lib/constants';
import i18n from './lib/i18n';
import { loadStorageData } from './lib/persistance/storage';
import { initGA } from './lib/tracking/initGA';
import { initGTM } from './lib/tracking/initGTM';
import { initMatomo } from './lib/tracking/initMatomo';
import { history, initStore } from './redux/initStore';
import { initLogger, log } from './utils/logger';

// init logger
initLogger();
log('Debug Logging is enabled');

// init store
const store = initStore(loadStorageData(SESSION_KEY_APP_STATE));

// init tracking
const matomoInstance = initMatomo();
initGA();
initGTM();

ReactDOM.render(
	<Provider store={store}>
		<ConnectedRouter history={history}>
			<I18nextProvider i18n={i18n}>
				<React.Suspense fallback={<div />}>
					<MatomoProvider value={matomoInstance}>
						<App />
					</MatomoProvider>
				</React.Suspense>
			</I18nextProvider>
		</ConnectedRouter>
	</Provider>,
	document.getElementById('root') as HTMLElement
);

// @ts-ignore
if (window.Cypress) {
	// @ts-ignore
	window.store = store;
}
